import type { ProviderAccountFeeInputDto } from '@/api/types/providers';

export type FeeBlock = Pick<
  ProviderAccountFeeInputDto,
  'depositFixedFee' | 'withdrawalFixedFee' | 'depositPercentageFee' | 'withdrawalPercentageFee'
>;

interface FeeInputsProps {
  idPrefix: string;
  value: FeeBlock;
  wrapperClass?: string;
  onChange: (next: FeeBlock) => void;
}

// Mirrors Partials/_FeeInputs.cshtml: four numeric fields (deposit/withdrawal
// fixed + percentage).
export function FeeInputs({ idPrefix, value, wrapperClass = 'mb-2', onChange }: FeeInputsProps) {
  function field(id: string, label: string, key: keyof FeeBlock) {
    return (
      <div className={`${wrapperClass} pa-required`}>
        <label htmlFor={id} className="form-label">
          {label}
        </label>
        <input
          id={id}
          type="number"
          step="any"
          className="form-control"
          value={Number.isNaN(value[key]) ? '' : value[key]}
          onChange={(e) => onChange({ ...value, [key]: toNumber(e.target.value) })}
        />
      </div>
    );
  }

  return (
    <>
      {field(`${idPrefix}-dep-fixed`, 'Deposit Fixed Fee', 'depositFixedFee')}
      {field(`${idPrefix}-wd-fixed`, 'Withdrawal Fixed Fee', 'withdrawalFixedFee')}
      {field(`${idPrefix}-dep-pct`, 'Percentage Fee On Deposit', 'depositPercentageFee')}
      {field(`${idPrefix}-wd-pct`, 'Percentage Fee On Withdrawal', 'withdrawalPercentageFee')}
    </>
  );
}

export function toNumber(raw: string): number {
  const v = parseFloat(String(raw).replace(/,/g, ''));
  return Number.isNaN(v) ? 0 : v;
}

export function emptyFeeBlock(): FeeBlock {
  return {
    depositFixedFee: 0,
    withdrawalFixedFee: 0,
    depositPercentageFee: 0,
    withdrawalPercentageFee: 0,
  };
}
